import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Academy } from './components/Academy';
import { BookingSystem } from './components/BookingSystem';
import { ColoristShowcase } from './components/ColoristShowcase';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-neon-violet/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <BookingSystem data-id="element-4" />
        <Academy data-id="element-5" />
        <ColoristShowcase data-id="element-6" />
        <About data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}